export type IOSNavigator = Pick<
  Navigator,
  "maxTouchPoints" | "platform" | "userAgent"
> & {
  standalone?: boolean;
};

export function isIOSDevice(navigatorLike: IOSNavigator): boolean {
  const classicIOSDevice = /iPad|iPhone|iPod/i.test(navigatorLike.userAgent);
  const modernIPad =
    navigatorLike.platform === "MacIntel" && navigatorLike.maxTouchPoints > 1;

  return classicIOSDevice || modernIPad;
}

export function isStandalonePwa(
  navigatorLike: IOSNavigator,
  standaloneDisplayMode: boolean,
): boolean {
  return standaloneDisplayMode || navigatorLike.standalone === true;
}

export function shouldShowIOSInstallPrompt({
  navigatorLike,
  standaloneDisplayMode,
  wasDismissed,
}: {
  navigatorLike: IOSNavigator;
  standaloneDisplayMode: boolean;
  wasDismissed: boolean;
}): boolean {
  return (
    isIOSDevice(navigatorLike) &&
    !isStandalonePwa(navigatorLike, standaloneDisplayMode) &&
    !wasDismissed
  );
}
